import { ConditionsService } from '../resources/conditions.service';
import { Model } from '../common/model';

export class ConditionModel extends Model {
  public static readonly TIME_SUNSET = 'time-sunset';
  public static readonly TIME_SUNRISE = 'time-sunrise';
  public static readonly TIME_DEFAULT = 'time';
  public static readonly TIME_RANDOM = 'time-random';
  public static readonly TIME_WINDOW = 'time-window';
  public static readonly TIME_INTERVAL = 'time-interval';
  public static readonly DEVICE_STATE = 'device-state';

  public static readonly SUNRISE = 'sunrise';
  public static readonly SUNSET = 'sunset';

  public static readonly CRONTAB = '#crontab';
  public static readonly EQ = '#eq';

  private _name: string;

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get type(): string {
    return this._data.type;
  }

  set type(value: string) {
    this._data.type = value;
  }

  get description(): string {
    return this._data.description;
  }

  set description(value: string) {
    this._data.description = value;
  }

  get componentId(): string | null {
    if (this.path) {
      const split = this.path.split('/');
      if (split && split.length > 4) {
        return split[4];
      }
    }

    return null;
  }

  get processorName(): string | null {
    if (this.path) {
      const split = this.path.split('/');
      if (split && split.length > 6) {
        return split[6];
      }
    }

    return null;
  }

  get attribute(): string | null {
    if (this.path) {
      const split = this.path.split('/');
      if (split && split.length > 8 && split[7] == 'attrs') {
        return split[8];
      }
    }

    return null;
  }

  get parents(): any {
    return this._data.parents;
  }

  set parents(value: any) {
    this._data.parents = value;
  }

  get path(): string {
    return this._data.path;
  }

  set path(value: string) {
    this._data.path = value;
  }

  get value(): any {
    return this._data.value;
  }

  set value(value: any) {
    this._data.value = value;
  }

  get days(): any {
    return this._data.days;
  }

  set days(value: any) {
    this._data.days = value;
  }

  get meta(): any {
    return this._data.meta;
  }

  set meta(value: any) {
    this._data.meta = value;
  }

  constructor(protected conditionsService: ConditionsService, data: any) {
    super(conditionsService, data);
  }
}
